import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import type { Offer } from '@innogy/become-a-customer/shared/interfaces';
import {
  FilterEntry,
  SegmentedControlEntry,
  SegmentedControlComponent,
} from '@legacy/common-ui-utility-components';
import { isDefined } from '@essent/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { ContractType } from '@essent/common';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'wl-commodity-offer-filter',
  templateUrl: './commodity-offer-filter.component.html',
  styleUrls: [
    './commodity-offer-filter.component.ed.scss',
    './commodity-offer-filter.component.essent.scss',
  ],
  standalone: true,
  imports: [CommonModule, SegmentedControlComponent],
})
export class CommodityOfferFilterComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() offers?: Offer[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() selectedContractType?: ContractType;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() availableContractTypes?: ContractType[];

  @Output() changeContractType = new EventEmitter<ContractType>();

  public readonly translateService = inject(TranslateService);

  mapToEntry(value: ContractType): FilterEntry<ContractType> {
    const translatedContractTypes = {
      [ContractType.FIXED]: this.translateService.instant('Fixed'),
      [ContractType.DYNAMIC]: this.translateService.instant('Dynamic'),
      [ContractType.VARIABLE]: this.translateService.instant('Flexible'),
    };

    return {
      id: value.toLocaleLowerCase(),
      value,
      text: translatedContractTypes[value],
    };
  }

  get entries(): FilterEntry<ContractType>[] {
    return (
      this.availableContractTypes
        ?.map((view) => this.mapToEntry(view))
        .filter(isDefined) ?? []
    );
  }

  get selectedEntry(): SegmentedControlEntry<ContractType> | undefined {
    return (
      this.selectedContractType && this.mapToEntry(this.selectedContractType)
    );
  }
}
